app.service('mopPaymentDataManager', function (sessionStorage) {

	const TOKENIZATION_STATUS = {
		REGISTERED: 'REGISTERED',
		NOT_REGISTERED: 'NOT_REGISTERED',
		ERROR: 'ERROR'
	};

	const PAYMENT_METHOD_ID = {
		E_CARD: 'E_CARD',
		E_CARD_RECURRING: 'E_CARD_RECURRING',
		BLIK: 'BLIK',
		BLIK_RECURRING: 'BLIK_RECURRING'
	};

	const STORAGE_KEY = 'payment-result';

	function mapPaymentMethodId(paymentMethodId) {
		if (!paymentMethodId) {
			return undefined;
		}
		if (paymentMethodId === 'E_CARD_RECURRING') {
			return PAYMENT_METHOD_ID.E_CARD_RECURRING;
		}
		if (paymentMethodId === 'E_CARD') {
			return PAYMENT_METHOD_ID.E_CARD;
		}
		if (paymentMethodId === 'BLIK_RECURRING') {
			return PAYMENT_METHOD_ID.BLIK_RECURRING;
		}
		if (paymentMethodId === 'BLIK') {
			return PAYMENT_METHOD_ID.BLIK;
		}
		throw new Error('Nieobsługiwana metoda płatności: ' + paymentMethodId);
	}

	function build(paymentData, config) {
		let tokenizationStatus;

		if (!paymentData || !paymentData.initialRecurrentTokenStatus) {
			tokenizationStatus = TOKENIZATION_STATUS.REGISTERED;
		} else if (paymentData.initialRecurrentTokenStatus === 'REGISTERED') {
			tokenizationStatus = TOKENIZATION_STATUS.REGISTERED;
		} else if (paymentData.initialRecurrentTokenStatus === 'NOT_REGISTERED') {
			tokenizationStatus = TOKENIZATION_STATUS.NOT_REGISTERED;
		} else {
			throw new Error('Nieobsługiwany status tokena przy płatności cyklicznej: ' + paymentData.initialRecurrentTokenStatus);
		}

		return {
			tokenizationStatus: tokenizationStatus,
			paymentId: config.paymentModuleDataId,
			orderNumber: config.orderNumber,
			processType: config.processType,
			paymentMethodId: config.processType === 'INSTALMENT'
				? mapPaymentMethodId(paymentData && paymentData.paymentMethodId)
				: (paymentData && paymentData.paymentMethodId)
		};
	}

	function buildError(config) {
		return {
			tokenizationStatus: TOKENIZATION_STATUS.ERROR,
			paymentId: config.paymentModuleDataId,
			orderNumber: config.orderNumber,
			processType: config.processType
		};
	}

	function save(paymentResult) {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(paymentResult));
	}

	function load() {
		var savedPaymentResultString = sessionStorage.getItem(STORAGE_KEY);

		if (!savedPaymentResultString) {
			return null;
		}

		sessionStorage.removeItem(STORAGE_KEY);

		try {
			return JSON.parse(savedPaymentResultString);
		} catch (e) {
			return null;
		}
	}

	function hasCorrectAccountRecurringPaymentData(paymentData, config) {
		if (config.pageType !== 'account-payment-module' || !paymentData || !config.processType) {
			return false;
		}

		if (paymentData.initialRecurrentTokenStatus && !['REGISTERED', 'NOT_REGISTERED'].includes(paymentData.initialRecurrentTokenStatus)) {
			throw new Error('Nieobsługiwany status tokena przy płatności cyklicznej: ' + paymentData.initialRecurrentTokenStatus);
		}

		if (!['PAYMENT', 'ACTIVATION', 'CHANGE_TOKEN', 'INSTALMENT', 'UPSELLING'].includes(config.processType)) {
			throw new Error('Nieobsługiwany typ procesu płatności: ' + config.processType);
		}

		return true;
	}

	return {
		TOKENIZATION_STATUS: TOKENIZATION_STATUS,
		PAYMENT_METHOD_ID: PAYMENT_METHOD_ID,
		build: build,
		buildError: buildError,
		save: save,
		load: load,
		hasCorrectAccountRecurringPaymentData: hasCorrectAccountRecurringPaymentData
	};
});
